<template>
  <div class="box1">
    <div class="box-bg"></div>
    <div class="main-box">
      <div class="text">每年开学5次，分别在1月、3月、5月、8月、10月，申请报名需在相应开学前1至2个月进行资料提交</div>
      <div class="red-text">开学时间可能会有微调<br/>具体以校方公布的时间为准</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  height: 886px;
  background: #fff;
  .box-bg {
    width: 100%;
    height: 640px;
    background: url("../../../assets/coursePage/illinois/box1/banner.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
  .main-box {
    font-family: PingFangSC, PingFang SC;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 40px;
    width: 670px;
    background: #FFFFFF;
    box-shadow: 0px 4px 38px 0px rgba(0,0,0,0.08);
    border-radius: 32px;
    .text {
      font-weight: 400;
      font-size: 30px;
      color: #272020;
      line-height: 48px;
      text-align: center;
    }
    .red-text {
      box-sizing: border-box;
      margin-top: 32px;
      padding-top: 24px;
      width: 590px;
      height: 144px;
      background: #FAF3F3;
      border-radius: 13px;
      font-weight: 500;
      font-size: 30px;
      color: #CC0001;
      line-height: 48px;
      text-align: center;
    }
  }
}
</style>
